import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit, OnDestroy {
  @Input() isVisible = false;
  @Input() errorTitle = '發生錯誤';
  @Input() errorMessage = '很抱歉，系統發生了未預期的錯誤，請稍後再試。';
  @Input() showBackButton = false;
  @Input() closeOnBackdropClick = true;
  @Output() closeError = new EventEmitter<void>();
  @Output() backRequested = new EventEmitter<void>();

  ngOnInit() {
    if (this.isVisible) {
      document.body.style.overflow = 'hidden';
    }
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

  close() {
    this.isVisible = false;
    document.body.style.overflow = '';
    this.closeError.emit();
  }

  goBack() {
    this.isVisible = false;
    document.body.style.overflow = '';
    this.backRequested.emit();
  }

  onBackdropClick() {
    if (this.closeOnBackdropClick) {
      this.close();
    }
  }
}
